import React, { useState } from 'react';
import { Navbar, NavDropdown, Container } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { logoutUser } from '../../services/authService';
import UpdatePasswordModal from '../../components/UpdatePasswordModal';
import { useProjects } from '../../context/ProjectContext';

const TopUserBar = () => {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const { projects } = useProjects();
  const user = JSON.parse(localStorage.getItem('user'));
  const [showPasswordModal, setShowPasswordModal] = useState(false);  // State to control modal visibility

  const getRoleName = (user) => {
    if (!user?.roles?.length) return null; // no roles
    return user.roles[0].name || null;     // first role's name
  };

  const handleLogout = () => {
    logoutUser();
    navigate('/login');
  };

  const handleChangePassword = () => {
    setShowPasswordModal(true);  // Open the modal for updating password
  };

  const handleClosePasswordModal = () => {
    setShowPasswordModal(false);  // Close the modal
  };

  return (
   <>
    <Navbar
      bg="light"
      expand="lg"
      className="shadow-sm"
      style={{ top: 0, padding: 20, position: 'sticky', zIndex: 1 }}
    >
      <Container fluid className="position-relative">
        {/* Centered brand */}
        <div style={{ letterSpacing: '.04em' }}
        >
          { projectId && <strong>{projects.find(p => p.id === Number(projectId))?.name}</strong> }
        </div>

        {/* Right side user menu */}
        <div className="ms-auto">
          <NavDropdown
            title={
              <>
                Hi {user?.username} - {getRoleName(user)}
              </>
            }
            align="end"
            id="user-nav-dropdown"
          >
            <NavDropdown.Item onClick={handleChangePassword}>
              Change Password
            </NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item onClick={handleLogout}>Logout</NavDropdown.Item>
          </NavDropdown>
        </div>
      </Container>
    </Navbar>

    {/* UpdatePasswordModal */}
    <UpdatePasswordModal
      user={user}
      show={showPasswordModal}
      onClose={handleClosePasswordModal}
      refetch={() => {}}
    />
  </>
  );
};

export default TopUserBar;
